import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'alphabeticSort',
    standalone: false
})
export class AlphabeticSortPipe implements PipeTransform {
  transform(inputList: any[], labelKey?: string): any[] {
    labelKey = labelKey ?? 'DisplayName';
    // Turkish alphabet with proper sorting order
    const alphabet = 'abcçdefgğhıijklmnoöpqrsştuüvwxyz';

    // Define a custom sorting function
    function turkishSort(a: any, b: any): number {
      // Check if label starts with "All "
      const labelA = a[labelKey].toLowerCase();
      const labelB = b[labelKey].toLowerCase();

      for (let i = 0; i < Math.min(labelA.length, labelB.length); i++) {
        const indexA = alphabet.indexOf(labelA[i]);
        const indexB = alphabet.indexOf(labelB[i]);
        if (indexA !== indexB) {
          return indexA - indexB;
        }
      }

      // If labels are equal up to the length of the shorter label, sort based on label length
      return labelA.length - labelB.length;
    }

    // Sort the list using the custom sorting function
    return inputList.sort(turkishSort);
  }
}
